import { defineMessages } from "react-intl";

export default defineMessages({
  "spRecurrenceModal.step1Title": {
    id: "spRecurrenceModal.step1Title",
    defaultMessage: "Planning a next job?",
  },
  "spRecurrenceModal.step1Body": {
    id: "spRecurrenceModal.step1Body",
    defaultMessage:
      "If you and your client agreed to work together again, initiate the job directly — ideal when a job ran over or can repeat regularly.",
  },
  "spRecurrenceModal.step2Title": {
    id: "spRecurrenceModal.step2Title",
    defaultMessage: "What does your client see?",
  },
  "spRecurrenceModal.step2Body": {
    id: "spRecurrenceModal.step2Body",
    defaultMessage:
      "They'll receive your offer and have 72 hours to accept or decline. A decline won't affect your completion rate — just keep communicating to avoid misunderstandings.",
  },
  "spRecurrenceModal.step3Title": {
    id: "spRecurrenceModal.step3Title",
    defaultMessage: "Boost your profile !",
  },
  "spRecurrenceModal.step3Body": {
    id: "spRecurrenceModal.step3Body",
    defaultMessage:
      "Regular clients build trust and bring you closer to the <superTalent>SuperTalent</superTalent> badge. Any issues at the client\u2019s home? Our support team will help you further.",
  },
});
